import { useLanguage } from "../contexts/LanguageContext";

export default function Privacy() {
  const { t } = useLanguage();

  return (
    <main data-testid="privacy-page" className="pt-28 pb-24 bg-[#0a0f1f]">
      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
        <h1 className="font-playfair text-4xl md:text-5xl text-[#f8f9fa] tracking-tight mb-12">
          {t("privacy.title")}
        </h1>

        <div className="prose-dark font-outfit text-[#94a3b8] leading-relaxed space-y-8 text-sm md:text-base">
          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">1. Responsable del Tratamiento</h2>
            <p>
              <strong className="text-[#f8f9fa]">Identidad:</strong> Sitayag SLU<br />
              <strong className="text-[#f8f9fa]">CIF:</strong> B45807344<br />
              <strong className="text-[#f8f9fa]">Domicilio:</strong> Plaza Grecia 1, Primera planta, Oficina 1, 45005 Toledo, Castilla-La Mancha, España<br />
              <strong className="text-[#f8f9fa]">Correo electrónico:</strong> info@sitayag.com<br />
              <strong className="text-[#f8f9fa]">Dominio web:</strong> medsim.es
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">2. Principios aplicados en el tratamiento de datos</h2>
            <p>En el tratamiento de sus datos personales, el Responsable del Tratamiento aplicará los siguientes principios que se ajustan a las exigencias del Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPD-GDD):</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong className="text-[#f8f9fa]">Principio de licitud, lealtad y transparencia:</strong> Se requerirá siempre el consentimiento del interesado para el tratamiento de sus datos personales.</li>
              <li><strong className="text-[#f8f9fa]">Principio de limitación de la finalidad:</strong> Los datos personales serán recogidos con fines determinados, explícitos y legítimos.</li>
              <li><strong className="text-[#f8f9fa]">Principio de minimización de datos:</strong> Los datos personales recogidos serán únicamente los estrictamente necesarios.</li>
              <li><strong className="text-[#f8f9fa]">Principio de exactitud:</strong> Los datos personales deben ser exactos y estar siempre actualizados.</li>
              <li><strong className="text-[#f8f9fa]">Principio de limitación del plazo de conservación:</strong> Los datos personales solo se mantendrán durante el tiempo necesario para los fines del tratamiento.</li>
              <li><strong className="text-[#f8f9fa]">Principio de integridad y confidencialidad:</strong> Los datos personales serán tratados de manera que se garantice una seguridad adecuada.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">3. Datos personales recogidos</h2>
            <p>Las categorías de datos personales que Sitayag SLU trata son:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Datos identificativos: nombre y apellidos</li>
              <li>Datos de contacto: correo electrónico</li>
              <li>Datos de comunicación: contenido del mensaje enviado a través del formulario de contacto</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">4. Finalidad del tratamiento</h2>
            <p>Los datos personales se recogen para las siguientes finalidades:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Gestionar las solicitudes de contacto y consultas recibidas a través del formulario web.</li>
              <li>Enviar comunicaciones relacionadas con los servicios ofrecidos, siempre con consentimiento previo.</li>
              <li>Cumplir con las obligaciones legales aplicables.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">5. Base jurídica del tratamiento</h2>
            <p>La base jurídica para el tratamiento de sus datos es:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong className="text-[#f8f9fa]">Consentimiento del interesado</strong> (Art. 6.1.a del RGPD): Al enviar el formulario de contacto, usted consiente el tratamiento de sus datos para la finalidad indicada.</li>
              <li><strong className="text-[#f8f9fa]">Interés legítimo</strong> (Art. 6.1.f del RGPD): Para la gestión y respuesta a las consultas recibidas.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">6. Período de conservación</h2>
            <p>Los datos personales proporcionados se conservarán mientras se mantenga la relación comercial o durante los años necesarios para cumplir con las obligaciones legales. Los datos se eliminarán cuando dejen de ser necesarios para la finalidad para la que fueron recogidos.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">7. Destinatarios de los datos</h2>
            <p>Los datos personales no serán cedidos a terceros salvo obligación legal. Se podrán comunicar a:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Proveedores de servicios tecnológicos necesarios para el funcionamiento de la plataforma.</li>
              <li>Autoridades competentes cuando exista obligación legal.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">8. Derechos del interesado</h2>
            <p>Conforme al RGPD y la LOPD-GDD, usted tiene derecho a:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong className="text-[#f8f9fa]">Acceso:</strong> Solicitar información sobre sus datos personales tratados.</li>
              <li><strong className="text-[#f8f9fa]">Rectificación:</strong> Solicitar la corrección de datos inexactos.</li>
              <li><strong className="text-[#f8f9fa]">Supresión:</strong> Solicitar la eliminación de sus datos personales.</li>
              <li><strong className="text-[#f8f9fa]">Limitación:</strong> Solicitar la limitación del tratamiento de sus datos.</li>
              <li><strong className="text-[#f8f9fa]">Portabilidad:</strong> Recibir sus datos en un formato estructurado.</li>
              <li><strong className="text-[#f8f9fa]">Oposición:</strong> Oponerse al tratamiento de sus datos personales.</li>
            </ul>
            <p className="mt-4">Para ejercer estos derechos, puede dirigirse a <a href="mailto:info@sitayag.com" className="text-[#1a6cf5] hover:underline">info@sitayag.com</a>.</p>
            <p>Asimismo, tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD) en <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-[#1a6cf5] hover:underline">www.aepd.es</a>.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">9. Cookies</h2>
            <p>Este sitio web utiliza cookies propias y de terceros para mejorar la experiencia del usuario. El usuario puede gestionar sus preferencias de cookies a través del mecanismo habilitado en el sitio web, que se muestra en la primera visita o según la configuración disponible. La aceptación o rechazo de cookies es libre y puede modificarse en cualquier momento.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">10. Seguridad de los datos</h2>
            <p>Sitayag SLU adopta las medidas técnicas y organizativas necesarias para garantizar la seguridad de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado, habida cuenta del estado de la tecnología, la naturaleza de los datos almacenados y los riesgos a que están expuestos, todo ello conforme a lo establecido en el RGPD y la legislación española vigente.</p>
          </section>

          <section>
            <h2 className="font-playfair text-2xl text-[#f8f9fa] mb-4">11. Legislación aplicable</h2>
            <p>La presente Política de Privacidad se rige por la legislación española y europea vigente en materia de protección de datos personales:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo (RGPD)</li>
              <li>Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPD-GDD)</li>
              <li>Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE)</li>
            </ul>
          </section>

          <p className="text-[#64748b] text-xs mt-12">Última actualización: Febrero 2026</p>
        </div>
      </div>
    </main>
  );
}
